import { UploadButton, UploadButtonProps } from '@components/Buttons/UploadButton';
import { Box, BoxProps } from '@material-ui/core';
import React from 'react';

export type ArquivoModalBarProps = Omit<BoxProps, "children"> & UploadButtonProps & {
}

export function ArquivoModalBar ({ accept, multiple, onFilesSelected, ...props }: ArquivoModalBarProps) {
    return (
        <Box {...props}>
            <UploadButton
                accept={accept}
                multiple={multiple !== false}
                onFilesSelected={onFilesSelected}
            />
        </Box>
    )
}